"use client"

import { StytchB2BProvider as B2BProvider } from "@stytch/nextjs/b2b"
import { createStytchB2BUIClient } from "@stytch/nextjs/b2b/ui"
import { ReactNode } from "react"

const stytchOptions = {
    cookieOptions: {
        opaqueTokenCookieName: "stytch_b2b_session",
        jwtCookieName: "stytch_b2b_session_jwt",
        path: "/",
        availableToSubdomains: false,
        domain: "",
    },
}

if (!process.env.NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN) {
    console.error("[StytchB2B] NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN is not set — B2B auth will not work")
}

const stytchB2BClient = createStytchB2BUIClient(
    process.env.NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN || "",
    stytchOptions
)

export function StytchB2BClientProvider({ children }: { children: ReactNode }) {
    return <B2BProvider stytch={stytchB2BClient}>{children}</B2BProvider>
}
